import React, { useState } from "react";
import { Box, useTheme } from "@mui/material";
import { useStyles } from "./styles";
import LandingBanner from "./LandingBanner";
import LoginSection from "./LoginSection";
import AboutSection from "./AboutSection";

const ContentPage: React.FC = () => {
  const theme = useTheme();
  const styles = useStyles();
  const [activeTab, setActiveTab] = useState<"user" | "admin">("user");

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue === 0 ? "user" : "admin");
  };

  return (
    <Box
      sx={{
        paddingX: { xs: 2, sm: 4, md: 8, lg: 14 },
        paddingY: { xs: 2 },
      }}
    >
      <LandingBanner />
      <LoginSection activeTab={activeTab} handleTabChange={handleTabChange} />
      <AboutSection />
    </Box>
  );
};

export default ContentPage;
